import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../../services/api';
import SweetAlert from 'react-bootstrap-sweetalert';
import InputMask from 'react-input-mask';
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer';
import './index.css';

function AtendimentoForm() {
  const { loja } = useParams();
  const [locais, setLocais] = useState([]);
  const [localSelecionado, setLocalSelecionado] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [codLoja, setCodLoja] = useState(null);

  const [nome, setNome] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [descricao, setDescricao] = useState('');
  const [empresa, setEmpresa] = useState('');
  const [setorSelecionado, setSetorSelecionado] = useState('');

  const [maskTelefone, setMaskTelefone] = useState('(99) 99999-9999');
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');
  const [senhaInfo, setSenhaInfo] = useState(null);
  const [cliId, setCliId] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [carregandoPosicao, setCarregandoPosicao] = useState(false);

  const intervaloRef = useRef(null);

  const onlyNumbers = (str) => str.replace(/\D/g, '');

  useEffect(() => {
    api.get(`/atendimento/loja/${loja}`)
      .then(res => {
        setLocais(res.data);
        if (res.data.length > 0) {
          setLocalSelecionado(res.data[0].atend_local);
          setCodLoja(res.data[0].atend_loja);
          if (res.data[0].atend_loja !== 1) {
            setShowPopup(true);
          } else {
            setMostrarFormulario(true);
          }
        }
      })
      .catch(() => setErro('Loja não encontrada!'))
      .finally(() => setCarregando(false));
  }, [loja]);

  // Buscar posição periodicamente
  useEffect(() => {
    if (!senhaInfo?.senha || !codLoja || !localSelecionado) return;

    intervaloRef.current = setInterval(async () => {
      try {
        setCarregandoPosicao(true);

        const res = await api.get('/atendimento/fila/posicao', {
          params: {
            cli_loja: codLoja,
            cli_local: localSelecionado,
            cli_senha: senhaInfo.senha
          }
        });

        const novaPosicao = res.data.Posicao;

        setSenhaInfo(prev => {
          if (!prev || novaPosicao !== prev.posicao) {
            return { ...prev, posicao: novaPosicao };
          }
          return prev;
        });

        if (novaPosicao === 0) {
          clearInterval(intervaloRef.current);
          intervaloRef.current = null;
        }
      } catch {
        console.log('Erro ao atualizar posição');
      } finally {
        setCarregandoPosicao(false);
      }
    }, 30000); // 30 segundos

    return () => clearInterval(intervaloRef.current);
  }, [senhaInfo?.senha, codLoja, localSelecionado]);

  useEffect(() => {
    if (erro) {
      const timer = setTimeout(() => setErro(''), 5000);
      return () => clearTimeout(timer);
    }
  }, [erro]);

  const limparCampos = () => {
    setNome('');
    setWhatsapp('');
    setDescricao('');
    setEmpresa('');
    setSetorSelecionado('');
    //setSenhaInfo(null);
  };

  const enviarSenha = async (tipo) => {
    const payload = {
      cli_loja: codLoja.toString(),
      cli_local: localSelecionado,
      cli_status: 'I',
      cli_tipo: tipo,
      cli_nome: '',
      cli_whatsapp: '',
      cli_descricao: '',
      cli_empresa: ''
    };
    try {
      const res = await api.post('/atendimento/fila', payload);
      setSenhaInfo(res.data[0]);
      setCliId(res.data[0].senha);
      setShowPopup(false);
      setSucesso("Aguarde ser atendido: Sua senha é: " + res.data[0].senha);
    } catch (err) {
      setErro('Erro ao solicitar senha.');
    }
  };

  const enviarAtendimento = async () => {
    if (!nome.trim() || !onlyNumbers(whatsapp) || !descricao.trim() || !codLoja || (codLoja === 1 && !setorSelecionado)) {
      setErro('Preencha todos os campos obrigatórios corretamente.');
      return;
    }
    const payload = {
      cli_loja: codLoja.toString(),
      cli_local: localSelecionado,
      cli_status: 'I',
      cli_tipo: codLoja === 1 ? 'A' : 'S',
      cli_nome: nome.trim(),
      cli_whatsapp: onlyNumbers(whatsapp),
      cli_descricao: descricao.trim(),
      cli_empresa: empresa.trim(),
      ...(codLoja === 1 && { cli_setor: setorSelecionado })
    };
    try {
      const res = await api.post('/atendimento/fila', payload);
      setSenhaInfo(res.data[0]);
      setCliId(res.data[0].senha);
      limparCampos();
      setMostrarFormulario(false);
      setSucesso("Aguarde ser atendido: Sua senha é: " + res.data[0].senha);
    } catch (err) {
      setErro('Erro ao enviar atendimento.');
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Menu modulo="Atendimento" />

      <div className="container-fluid pagina-dados" style={{ flex: '1 0 auto' }}>
        <div className="offset-lg-3 col-lg-6">

          {carregando ? (
            <div className="text-center mt-5">Carregando...</div>
          ) : (
            <>
              {showPopup && !mostrarFormulario && (
                <div className="popup-atendimento">
                  <h5>Escolha o tipo de atendimento</h5>
                  <p><b>Local:</b> {localSelecionado}</p>

                  {locais.length > 1 && (
                    <div className="mb-2">
                      <select className="form-control" value={localSelecionado} onChange={(e) => setLocalSelecionado(e.target.value)}>
                        {locais.map((l, i) => (
                          <option key={i} value={l.atend_local}>{l.atend_local}</option>
                        ))}
                      </select>
                    </div>
                  )}

                  <button className="btn btn-primary w-100 mb-2" onClick={() => enviarSenha('B')}>Senha BALCÃO</button>
                  <button className="btn btn-warning w-100 mb-2" onClick={() => enviarSenha('P')}>Senha PRIORITÁRIO</button>
                  <button className="btn btn-success w-100" onClick={() => {
                    setMostrarFormulario(true);
                    setShowPopup(false);
                  }}>Separação de Produtos</button>
                </div>
              )}

              {mostrarFormulario && (
                <>
                  <h3 className="mt-4 mb-3">Solicitar Separação de Produtos</h3>
                  <div className="mb-3">
                    <label className="form-label">Nome</label>
                    <input
                      className="form-control"
                      type="text"
                      value={nome}
                      onChange={(e) => setNome(e.target.value)}
                      placeholder="Digite seu nome"
                      maxLength={50} // Limite CLI_NOME
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">WhatsApp</label>
                    <InputMask
                      className="form-control"
                      mask={maskTelefone}
                      value={whatsapp}
                      onChange={(e) => setWhatsapp(e.target.value)}
                      placeholder="(99) 99999-9999"
                    // O banco aceita 11 dígitos (CLI_WHATSAPP)
                    />
                  </div>

                  {codLoja === 1 && (
                    <>
                      <div className="mb-3">
                        <label className="form-label">Empresa</label>
                        <input
                          className="form-control"
                          type="text"
                          value={empresa}
                          onChange={(e) => setEmpresa(e.target.value)}
                          placeholder="Empresa ou setor"
                          maxLength={30} // Limite CLI_EMPRESA
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Setor</label>
                        <div className="d-flex flex-column">
                          {['COMERCIAL', 'RECURSOS HUMANOS', 'CONTABILIDADE', 'FINANCEIRO', 'JURIDICO', 'PSCICOLOGA',].map((setor, index) => (
                            <div className="form-check" key={index}>
                              <input
                                className="form-check-input"
                                type="radio"
                                name="setor"
                                id={`setor-${index}`}
                                value={setor}
                                checked={setorSelecionado === setor}
                                onChange={() => setSetorSelecionado(setor)}
                              />
                              <label className="form-check-label" htmlFor={`setor-${index}`}>{setor}</label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  )}

                  <div className="mb-3">
                    <label className="form-label">
                      {codLoja === 1 ? 'Descrição' : 'Pedido'}
                    </label>
                    <textarea
                      className="form-control"
                      rows={3}
                      value={descricao}
                      onChange={(e) => setDescricao(e.target.value)}
                      placeholder={codLoja === 1 ? 'Informe o assunto' : 'Informe os produtos desejados'}
                    // CLI_DESCRICAO é CLOB, não requer limite rigoroso no front
                    />
                  </div>

                  <div className="container-fluid pagina-dados" style={{ flex: '1 0 auto' }}>
                    <div className="offset-lg-3 col-lg-6">
                      {/* ... seu conteúdo ... */}
                      <button className="btn btn-primary w-100" onClick={enviarAtendimento}>
                        Enviar
                      </button>
                    </div>
                  </div>
                </>
              )}

              {senhaInfo && (
                <div className="alert alert-success mt-4 text-center">
                  <h5>Sua senha: <b>{senhaInfo.senha}</b></h5>

                  {carregandoPosicao && (
                    <div className="d-flex justify-content-center my-2">
                      <div className="spinner-border text-success" role="status" style={{ width: '2rem', height: '2rem' }}>
                        <span className="visually-hidden">Carregando...</span>
                      </div>
                    </div>
                  )}

                  {senhaInfo.posicao !== undefined && (
                    senhaInfo.posicao === 1
                      ? <p className="posicao-animada">Você é o próximo</p>
                      : <p className="posicao-animada">Sua posição é: {senhaInfo.posicao}</p>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {erro && (
        <SweetAlert danger title="Erro" onConfirm={() => setErro('')}>{erro}</SweetAlert>
      )}

      {sucesso && (
        <SweetAlert success title="Sucesso" onConfirm={() => setSucesso('')}>{sucesso}</SweetAlert>
      )}

      <Footer className="footer navbar-fixed-bottom" />
    </div>
  );
}

export default AtendimentoForm;
